var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-section"},[_c('b-field',{staticClass:"input-field",attrs:{"label":"Dimension","type":_vm.errors.length ? 'is-danger' : '',"message":_vm.errors.map(e => e.msg).join(', ')}},[_c('CompanyDimensionRefSelect',{model:{value:(_vm.inputs),callback:function ($$v) {_vm.inputs=$$v},expression:"inputs"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }